const NotificationSkeleton: React.FC = () => (
  <div className="p-5 transition animate-pulse">
    <div className="flex flex-col">
      <div className="flex items-center justify-between gap-3 mb-2">
        <div className="h-6 w-24 bg-gray-200 rounded-full"></div>{' '}
        {/* Type skeleton */}
        <div className="h-4 w-16 bg-gray-200 rounded"></div>{' '}
        {/* Time skeleton */}
      </div>
      <div className="h-5 w-3/4 bg-gray-200 rounded mb-1"></div>{' '}
      {/* Title skeleton */}
      <div className="h-4 w-5/6 bg-gray-200 rounded"></div>{' '}
      {/* Message skeleton */}
    </div>
  </div>
);

export default NotificationSkeleton;
